/**
 * FAVORİLER (Wishlist)
 *
 * Header "FAVORİLERİM" diyor ama arkasında sistem yoktu — boş vaat.
 * Bu dosya onu gerçek yapar.
 *
 * TASARIM KARARI: localStorage. Neden?
 *   • Uygulama gerektirmez (aylık ücret yok, JS yükü yok)
 *   • Üyelik gerektirmez — Baymard: favori için üyelik zorunlu kılmak
 *     sitelerin %89'unun yaptığı hata; ziyaretçiyi kaçırır
 *   • Anında çalışır, sunucu turu yok
 *
 * SINIRI (dürüstçe): Cihaza bağlıdır. Telefonda eklediğin bilgisayarda görünmez.
 * Cihazlar arası senkron isteniyorsa müşteri hesabı + metafield gerekir.
 */
(function () {
  'use strict';

  var ANAHTAR = 'moon_favoriler';

  function oku() {
    try {
      var v = JSON.parse(localStorage.getItem(ANAHTAR));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function yaz(liste) {
    try {
      localStorage.setItem(ANAHTAR, JSON.stringify(liste));
    } catch (e) {}
    sayaciGuncelle(liste.length);
    document.dispatchEvent(new CustomEvent('favoriler:degisti', { detail: { liste: liste } }));
  }

  function ekliMi(handle) {
    return oku().indexOf(handle) !== -1;
  }

  function degistir(handle) {
    var liste = oku();
    var i = liste.indexOf(handle);
    if (i === -1) {
      liste.unshift(handle);
    } else {
      liste.splice(i, 1);
    }
    yaz(liste);
    return i === -1; // true = eklendi
  }

  function sayaciGuncelle(n) {
    document.querySelectorAll('[data-fav-sayac]').forEach(function (el) {
      el.textContent = n > 0 ? '(' + n + ')' : '';
    });
  }

  /* ── Kalp butonlarının görsel durumunu tazele ── */
  function butonlariTazele() {
    document.querySelectorAll('[data-fav-btn]').forEach(function (btn) {
      var h = btn.dataset.favBtn;
      var ekli = ekliMi(h);
      btn.classList.toggle('is-fav', ekli);
      btn.setAttribute('aria-pressed', ekli ? 'true' : 'false');
      btn.setAttribute('aria-label', ekli ? 'Favorilerden çıkar' : 'Favorilere ekle');
    });
  }

  /* ── Tıklama (olay delegasyonu — filtreleme sonrası gelen kartlarda da çalışır) ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fav-btn]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var handle = btn.dataset.favBtn;
    if (!handle) return;

    degistir(handle);
    butonlariTazele();

    // Kısa dokunsal geri bildirim (kalbin dolması yeterli — abartma)
    btn.classList.add('is-atiyor');
    setTimeout(function () { btn.classList.remove('is-atiyor'); }, 320);
  });

  /* ── Favoriler sayfası: listeyi Shopify'ın kendi ucundan doldur ── */
  function paraFormat(kurus) {
    var t = (kurus / 100).toFixed(2).replace('.', ',');
    return t.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' TL';
  }

  function favoriSayfasiniDoldur() {
    var kok = document.querySelector('[data-fav-sayfa]');
    if (!kok) return;

    var grid = kok.querySelector('[data-fav-grid]');
    var bos = kok.querySelector('[data-fav-bos]');
    var liste = oku();

    grid.innerHTML = '';

    if (!liste.length) {
      bos.hidden = false;
      grid.hidden = true;
      return;
    }

    bos.hidden = true;
    grid.hidden = false;

    Promise.all(
      liste.map(function (handle) {
        return fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (urunler) {
      var gecerli = urunler.filter(Boolean);

      // Artık var olmayan ürünleri listeden düş
      var gecerliHandle = gecerli.map(function (u) { return u.handle; });
      yaz(oku().filter(function (h) { return gecerliHandle.indexOf(h) !== -1; }));

      if (!gecerli.length) {
        bos.hidden = false;
        grid.hidden = true;
        return;
      }

      gecerli.forEach(function (u) {
        var gorsel = u.featured_image || (u.images && u.images[0]) || '';
        var src = gorsel ? gorsel.replace(/(\.[a-z]+)(\?.*)?$/i, '_600x$1') : '';
        var indirimli = u.compare_at_price && u.compare_at_price > u.price;

        var li = document.createElement('li');
        li.className = 'fav__kart';
        li.innerHTML =
          '<div class="fav__media">' +
            '<a href="' + u.url + '" class="fav__link">' +
              (src ? '<img src="' + src + '" alt="" loading="lazy" width="600" height="800">' : '') +
            '</a>' +
            '<button type="button" class="fav__kalp is-fav" data-fav-btn="' + u.handle + '" aria-pressed="true" aria-label="Favorilerden çıkar">' +
              '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 5.6a5 5 0 0 0-7.1 0L12 7.3l-1.7-1.7a5 5 0 1 0-7.1 7.1l8.8 8.8 8.8-8.8a5 5 0 0 0 0-7.1z"/></svg>' +
            '</button>' +
          '</div>' +
          '<a href="' + u.url + '" class="fav__ad">' + u.title + '</a>' +
          '<p class="fav__fiyat">' +
            (indirimli ? '<s>' + paraFormat(u.compare_at_price) + '</s> ' : '') +
            '<span' + (indirimli ? ' class="fav__indirim"' : '') + '>' + paraFormat(u.price) + '</span>' +
          '</p>';
        grid.appendChild(li);
      });
    });
  }

  /* ── Başlat ── */
  function baslat() {
    sayaciGuncelle(oku().length);
    butonlariTazele();
    favoriSayfasiniDoldur();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else {
    baslat();
  }

  // Favoriler sayfasında bir ürün çıkarılınca listeyi yeniden çiz
  document.addEventListener('favoriler:degisti', function () {
    if (document.querySelector('[data-fav-sayfa]')) {
      // Kartı yumuşakça kaldır, sonra yeniden çiz
      setTimeout(favoriSayfasiniDoldur, 200);
    }
  });

  document.addEventListener('shopify:section:load', baslat);
})();
